import { render, staticRenderFns } from "./AppDocuments.vue?vue&type=template&id=41211c02"
import script from "./AppDocuments.vue?vue&type=script&lang=js"
export * from "./AppDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports